import { Dropdown } from "antd";
import { MailSortBy } from "../Stores/EmailTypeStore";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface SortingDropdownProps {
  onSort: (sortBy: MailSortBy, sortOrder: API_MAILPAGINATION_SORTORDER) => void;
  sortedBy: MailSortBy;
  sortedOrder: API_MAILPAGINATION_SORTORDER;
  emailType: API_MAILS_TYPE;
}

const sortByTitleMap: { [key in MailSortBy]: string } = {
  timestamp: "Date",
  from: "From",
  subject: "Subject",
  hasAttachments: "Attachments",
  importance: "Importance",
};

export const SortingDropdown = ({ onSort, sortedBy, sortedOrder, emailType }: SortingDropdownProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const handleClick = ({ key }) => {
    const [menuType, sortKey] = key.split("_");

    if (menuType === "sortedBy") {
      onSort(sortKey as MailSortBy, sortedOrder);
    } else if (menuType === "sortedOrder") {
      onSort(sortedBy, sortKey as API_MAILPAGINATION_SORTORDER);
    }
  };

  return (
    <Dropdown
      menu={{
        items: [
          {
            type: "group",
            label: t("Sort by"),
            children: [
              {
                key: "sortedBy_timestamp",
                label: t("Date"),
              },
              emailType !== "SENT" &&
                emailType !== "DRAFT" && {
                  key: "sortedBy_from",
                  label: t("From"),
                },
              {
                key: "sortedBy_subject",
                label: t("Subject"),
              },
              {
                key: "sortedBy_hasAttachments",
                label: t("Attachments"),
              },
              {
                key: "sortedBy_importance",
                label: t("Importance"),
              },
            ],
          },
          {
            type: "group",
            label: t("Sort order"),
            children: [
              {
                key: "sortedOrder_ASC",
                label: t("Ascending"),
              },
              {
                key: "sortedOrder_DESC",
                label: t("Descending"),
              },
            ],
          },
        ],
        className: "hide-bullets",
        selectedKeys: [sortedBy, sortedOrder],
        onClick: handleClick,
      }}
      trigger={["click"]}
    >
      <div className="sort-dropdown-btn" style={{ marginRight: 10 }}>
        {t("Sorted by")}: {t(sortByTitleMap[sortedBy])}
        <FontAwesomeIcon fixedWidth={true} icon={["fas", "sort-down"]} transform="up-2" />
      </div>
    </Dropdown>
  );
};
